import React from "react";
import { Space } from "antd";
import { AxPassword, AxDivider, AxButton } from "@dynata/axiom3";

class Password extends React.Component {
  render() {
    return (
      <div className="section" id="password">
        <h3>Password</h3>
        <p>Simple password input with various size options.</p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space direction="vertical">
          <Space size="large" direction="vertical">
            <pre>{`<AxPassword/>`}</pre>
            <div className="prop-header">
              <p className="props-title">Props</p>
              <p>
                For AntD props, visit{" "}
                <AxButton
                  size="small"
                  type="link"
                  target="_blank"
                  href="https://ant.design/components/input/#Input.Password"
                >
                  https://ant.design/components/input/#Input.Password
                </AxButton>
              </p>
            </div>

            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>size</td>
                  <td>Default is, medium</td>
                  <td>small | medium | large | xlarge</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>iconRender</td>
                  <td>Custom toggle button</td>
                  <td>(visible) =&gt; ReactNode</td>
                  <td>
                    (visible) =&gt; (visible ? &lt;EyeOutlined /&gt; :
                    &lt;EyeInvisibleOutlined /&gt;)
                  </td>
                  <td>4.3.0</td>
                </tr>
                <tr>
                  <td>visibilityToggle</td>
                  <td>Whether show toggle button</td>
                  <td>boolean</td>
                  <td>true</td>
                  <td></td>
                </tr>
                <tr>
                  <td>...others</td>
                  <td>
                    All extra props are passed down to the{" "}
                    <>
                      <AxButton
                        size="small"
                        type="link"
                        target="_blank"
                        href="https://4x.ant.design/components/input/#Input.Password"
                      >
                        {`<Input.Password />`}
                      </AxButton>
                    </>{" "}
                    component.
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <pre>{`<AxPassword placeholder="AxPassword" size="small" />
<AxPassword placeholder="AxPassword" />
<AxPassword placeholder="AxPassword" disabled />
<AxPassword placeholder="AxPassword" size="large" />
<AxPassword placeholder="AxPassword" size="xlarge" />
            `}</pre>
          </Space>
        </Space>

        <AxDivider orientation="left" plain>
          Small | Medium | Disabled | Large | XLarge
        </AxDivider>

        <Space direction="vertical" size={40}>
          <AxPassword placeholder="AxPassword" size="small" />
          <AxPassword placeholder="AxPassword" />
          <AxPassword placeholder="AxPassword" disabled />
          <AxPassword placeholder="AxPassword" size="large" />
          <AxPassword placeholder="AxPassword" size="xlarge" />
        </Space>
      </div>
    );
  }
}
export default Password;
